function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
class LogicalPermission {
  constructor({
    pk,
    name,
    permissions,
    is_active,
    is_deleted,
    is_private = true
  }) {
    _defineProperty(this, "mapToSnakeCase", () => {
      return {
        pk: this.pk,
        name: this.name,
        permissions: this.permissions,
        is_active: this.isActive,
        is_private: this.isPrivate
      };
    });
    this.pk = pk;
    this.name = name;
    this.permissions = permissions;
    this.isActive = is_active;
    this.isPrivate = is_private;
    this.isDeleted = is_deleted;
  }
}
export default LogicalPermission;